import Star from '../../img/star.svg';
const Avis = () => {
    return(
        <div className="container-avis pl-16 min-[320px]:pl-4">
            <div className="container-avis-title">
                <h2 className="text-f-40 font-bold">Vos avis comptent<span>.</span></h2>
            </div>
            <div className="container-avis-blocs">
                <div className="card-avis p-6">
                    <div className="star mb-4">
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                    </div>
                    <p>Simon a travaillé avec nous sur une campagne de collecte pour financer des ordinateurs au profit de jeunes, de familles et de retraités en situation précaire. Il a fait preuve d'engagement, de flexibilité et de professionnalisme. Il a su comprendre nos besoins et capter les images (photo et videos) pour illustrer notre campagne. Merci!</p>
                    <p className="person mt-4">Sophie Perez</p>
                </div>
                <div className="card-avis p-6">
                    <div className="star mb-4">
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                    </div>
                    <p>J'ai eu l'occasion de travailler à plusieurs reprises avec Focus Production, le travail a toujours été extrêmement bien réalisé, avec beaucoup de soins et de professionnalisme et cela concerne l'ensemble des intervenants. Les délais ont toujours été respectés. Je recommande vivement cette entreprise qui saura vous conseiller et répondre à vos besoins pour la réalisation de vidéos professionnelles de qualité
                    </p>
                    <p className="person mt-4">Frédéric Soler</p>
                </div>
                <div className="card-avis p-6">
                    <div className="star mb-4">
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                        <img alt="etoile des avis" src={Star}/>
                    </div>
                    <p>Les recommandations sont importantes! Je suis donc ravis de placer en avant votre entreprise pour ses services. Vous avez sue placé en avant mon image professionelle au saint de la haute joiallerie anssi que mon entreprise. Il est donc bien évident que je referais appelle a vous. Coordiallement et a bientot de la par de Jeremy Boueilh.
                    </p>
                    <p className="person mt-4">Jérémy Boueilh</p>
                </div>
            </div>
        </div>
    )
}

export default Avis